import React from "react";
import "./structureList.scss";

import RecursiveStructureItem from "./RecursiveStructureItem";

const StructureList = ({ isDouble, listData, isAllOpen, isShowIframes }) => {
    return (
        <div className="structure-list">
            <div className="structure-list__column">
                {listData.map((structureItem, index) => {
                    return (
                        <RecursiveStructureItem
                            itemData={structureItem}
                            index={index}
                            isItFirst={true}
                            key={structureItem.id + structureItem.title}
                            isAllOpen={isAllOpen}
                            isShowIframes={isShowIframes}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default StructureList;
